import React from "react";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";
import { STATUS } from "utils/constants/ui";
import { NO_OP } from "utils/action";

const DEFAULT_COPY = "Menu";
const DEFAULT_CLASSES = {
  container:
    "flex flex-row pointer items-center ba bg-white bg-white--hover br2 ph2 pv1 f6 fw5",
  copy: "pr1",
  suffix: "dib pl1 ml1 bl flex"
};

const STATUS_CLASSES = {
  [STATUS.DEFAULT]: "b--primary color-primary",
  [STATUS.NEUTRAL]: "b--black-30 bg-white--hover color-secondary black-70"
};

const STATUS_COLORS = {
  [STATUS.DEFAULT]: COLORS.blue,
  [STATUS.NEUTRAL]: COLORS.primary
};

const Trigger = ({ onClick, copy, icon, customClasses, status }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const ctxCopy = copy || DEFAULT_COPY;
  const Icon = getIconForUID(icon);
  const ctxStatus = status || STATUS.DEFAULT;
  const statusClasses = STATUS_CLASSES[ctxStatus];
  const statusColor = STATUS_COLORS[ctxStatus];

  return (
    <div
      className={`${classes.container} ${statusClasses}`}
      onClick={onClick || NO_OP}
    >
      <div className={classes.copy}>
        <div>{ctxCopy}</div>
      </div>
      <div className={`${classes.suffix} ${statusClasses}`}>
        {icon ? <Icon size={16} color={statusColor} /> : <div>⌘K</div>}
      </div>
    </div>
  );
};

export default Trigger;
